import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { t } from 'utils/translates';

import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';
import { getValueFromRefDataModules } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

class TypesTasksInputs extends Component {
  componentWillMount() {
    this.delayedCallback = _.debounce(() => {
      this.props.sendRequest();
    }, 800);
  }

  componentWillUnmount() {
    this.delayedCallback.cancel();
  }

  getValuesAsArray = () =>
    this.props.selectQueryParams.type_ids
      ? this.props.selectQueryParams.type_ids.split(',')
      : [];

  handleChange = e => {
    const checkedValues = this.getValuesAsArray();
    let index;
    console.log(e.target.checked);
    console.log(e.target.value);
    if (e.target.checked) {
      checkedValues.push(e.target.value);
    } else {
      index = checkedValues.indexOf(e.target.value);
      checkedValues.splice(index, 1);
    }
    this.props.changeQueryParams({
      type_ids: checkedValues.join(','),
      page: 1
    });
    this.delayedCallback();
  };

  render() {
    const checkedValues = this.getValuesAsArray();
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="panelGroupFilter_h_2">
          <a
            className="dropdown-toggle dropdown-toggle-collapse"
            role="button"
            data-toggle="collapse"
            href="#panelGroupFilter_c_2"
            aria-expanded="false"
            aria-controls="panelGroupFilter_c_2"
          >
            {t('Категория')}
          </a>
        </div>
        <div
          id="panelGroupFilter_c_2"
          className="panel-collapse collapse in"
          role="tabpanel"
          aria-labelledby="panelGroupFilter_h_2"
        >
          <div className="panel-body">
            <div className="form-group form-group-sm m-b-0">
              <div className="form-group m-b-0">
                <div className="control-group">
                  {this.props.taskTypes.map(item => {
                    if (item.status === 1) {
                      return (
                        <div
                          key={`taskTypeSearch-${item.value + 1}`}
                          className="checkbox abc-checkbox abc-checkbox-primary"
                        >
                          <input
                            id={`taskTypeSearchCheckbox${item.value}`}
                            className="styled"
                            type="checkbox"
                            checked={checkedValues.includes(
                              item.value.toString()
                            )}
                            value={item.value}
                            onChange={this.handleChange}
                          />
                          <label
                            htmlFor={`taskTypeSearchCheckbox${item.value}`}
                          >
                            {item.title}
                          </label>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TypesTasksInputs.propTypes = {
  // CONNECT
  selectQueryParams: PropTypes.shape({
    type_ids: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  taskTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName),
  taskTypes: getValueFromRefDataModules(state, 'tasks.taskTypes')
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.listReduceName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TypesTasksInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/TypesTasksInputs/TypesTasksInputs.js